import {
  FETCH_CANCELLATIONS_REQUEST,
  FETCH_CANCELLATIONS_SUCCESS,
  FETCH_CANCELLATIONS_FAILURE,
  CREATE_CANCELLATION_INVOICE_REQUEST,
  CREATE_CANCELLATION_INVOICE_SUCCESS,
  CREATE_CANCELLATION_INVOICE_FAILURE,
  UPDATE_CANCELLATION_STATUS_REQUEST,
  UPDATE_CANCELLATION_STATUS_SUCCESS,
  UPDATE_CANCELLATION_STATUS_FAILURE,
  FETCH_CANCELLATION_STATISTICS_REQUEST,
  FETCH_CANCELLATION_STATISTICS_SUCCESS,
  FETCH_CANCELLATION_STATISTICS_FAILURE,
} from "./actionTypes";

// Fetch Cancellations Actions
export const fetchCancellationsRequest = (providerId) => ({
  type: FETCH_CANCELLATIONS_REQUEST,
  payload: providerId,
});

export const fetchCancellationsSuccess = (data) => ({
  type: FETCH_CANCELLATIONS_SUCCESS,
  payload: data,
});

export const fetchCancellationsFailure = (error) => ({
  type: FETCH_CANCELLATIONS_FAILURE,
  payload: error,
});

// Create Cancellation Invoice Actions
export const createCancellationInvoiceRequest = (orderData, serviceProviderId, reason) => ({
  type: CREATE_CANCELLATION_INVOICE_REQUEST,
  payload: { orderData, serviceProviderId, reason },
});

export const createCancellationInvoiceSuccess = (data) => ({
  type: CREATE_CANCELLATION_INVOICE_SUCCESS,
  payload: data,
});

export const createCancellationInvoiceFailure = (error) => ({
  type: CREATE_CANCELLATION_INVOICE_FAILURE,
  payload: error,
});

// Update Cancellation Status Actions
export const updateCancellationStatusRequest = (cancellationId, newStatus) => ({
  type: UPDATE_CANCELLATION_STATUS_REQUEST,
  payload: { cancellationId, newStatus },
});

export const updateCancellationStatusSuccess = (data) => ({
  type: UPDATE_CANCELLATION_STATUS_SUCCESS,
  payload: data,
});

export const updateCancellationStatusFailure = (error) => ({
  type: UPDATE_CANCELLATION_STATUS_FAILURE,
  payload: error,
});

// Fetch Cancellation Statistics Actions
export const fetchCancellationStatisticsRequest = (providerId) => ({
  type: FETCH_CANCELLATION_STATISTICS_REQUEST,
  payload: providerId,
});

export const fetchCancellationStatisticsSuccess = (data) => ({
  type: FETCH_CANCELLATION_STATISTICS_SUCCESS,
  payload: data,
});

export const fetchCancellationStatisticsFailure = (error) => ({
  type: FETCH_CANCELLATION_STATISTICS_FAILURE,
  payload: error,
});
